import {doesRect1Inside2} from 'utils/domRect';

export default function placeTooltip(
  parent: DOMRect,
  tooltip: DOMRect,
  target: DOMRect,
  margin = 0,
): DOMRect {
  const candidates: DOMRect[] = [];
  for (const tooltipX of [
    target.left + target.width + margin,
    target.left - tooltip.width - margin,
  ]) {
    for (const tooltipRelY of [0.5, 0, 1]) {
      candidates.push(
        new DOMRect(
          tooltipX,
          target.top + (target.height - tooltip.height) * tooltipRelY,
          tooltip.width,
          tooltip.height,
        ),
      );
    }
  }
  for (const tooltipY of [
    target.top - tooltip.height - margin,
    target.top + target.height + margin,
  ]) {
    for (const tooltipRelX of [0.5, 0, 1]) {
      candidates.push(
        new DOMRect(
          target.left + (target.width - tooltip.width) * tooltipRelX,
          tooltipY,
          tooltip.width,
          tooltip.height,
        ),
      );
    }
  }
  for (const candidate of candidates) {
    if (doesRect1Inside2(candidate, parent)) {
      return candidate;
    }
  }
  return new DOMRect(
    parent.x + parent.width / 2 - tooltip.width / 2,
    parent.y + parent.height / 2 - tooltip.height / 2,
    tooltip.width,
    tooltip.height,
  );
}
